import React from "react";
import { Card, CardBody, Col, Row, Spinner } from "reactstrap";
import approved from "./approvedreqs.png";
import disbursed from "./totaldisbursed.png";
import totalreqs from "./totalreqs.png";
import totalapproved from "./totalapproved.png";
import average from "./averagesize.png";

const cardData = [
  {
    image: totalreqs,
    title: "Total Loan Requests",
    color: "#00cd72",
  },
  {
    image: approved,
    title: "Approved Loan Requests",
    color: "#18a07a",
    data: "bank_approved_loans",
  },
  {
    image: disbursed,
    title: "Total Amount Disbursed",
    color: "#29aac5",
    data: "total_amount_disbursed",
  },
  {
    image: totalapproved,
    title: "Total Approved Amount",
    color: "#f1ad02",
    data: "total_approved_amount",
  },
  {
    image: average,
    title: "Average Loan Size",
    color: "#727272",
    data: "average_loan_size",
  },
];

const TopCards = ({ loanStatsData, loading }) => {
  const totalLoanRequests =
    (loanStatsData && loanStatsData.bank_approved_loans) +
    (loanStatsData && loanStatsData.beythak_approved_loans) +
    (loanStatsData && loanStatsData.bank_rejected_loans) +
    (loanStatsData && loanStatsData.beythak_rejected_loans) +
    (loanStatsData && loanStatsData.pending_loans);
  return (
    <div className="justify-content-center mb-3">
      <Row >
        {cardData.map((card, index) => (
          <Col key={index}>
            <Card
              style={{
                borderRadius: "20px",
                width: "auto",
                height:"90%",
                backgroundColor: card.color,
              }}
            >
              <div className="card-body">
                {loading ? (
                  <div className="text-center" style={{ marginTop: "40px" }}>
                    <Spinner className="mr-2" color="light" />
                  </div>
                ) : (
                  <>
                    <img src={card.image} alt="total" width="60px" />
                    <h6 style={{ color: "white", marginTop: "50px" }}>
                      {card.title}
                    </h6>
                    {card.title === "Total Loan Requests" ? (
                      <h5 style={{ color: "white", fontWeight: "bold" }}>
                        {totalLoanRequests}
                      </h5>
                    ) : (
                      <>
                        {card.title === "Total Amount Disbursed" ||
                        card.title === "Total Approved Amount" ||
                        card.title === "Average Loan Size" ? (
                          <h5 style={{ color: "white", fontWeight: "bold" }}>
                            Rs.{" "}
                            {loanStatsData &&
                              loanStatsData[card.data]
                                .toLocaleString("en-US", {
                                  maximumFractionDigits: 2,
                                })}
                            /-
                          </h5>
                        ) : (
                          <h5 style={{ color: "white", fontWeight: "bold" }}>
                            {loanStatsData && loanStatsData[card.data]}
                          </h5>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TopCards;
